
import GwSection from '~/patterns/organisms/section/section.vue';
import RichText from '~/patterns/molecules/rich-text/rich-text.vue';

export default {
    components: {
        RichText,
        GwSection
    },

    props: {
        richText: {
            type: String,
            required: true,
            default: null
        },

        heading: {
            type: String,
            required: false,
            default: null
        },

        textWidth: {
            type: String,
            required: false,
            default: 'content'
        }
    }
};
